import { render, staticRenderFns } from "./TourOverlay.vue?vue&type=template&id=10c22780&scoped=true&"
import script from "./TourOverlay.vue?vue&type=script&lang=js&"
export * from "./TourOverlay.vue?vue&type=script&lang=js&"
import style0 from "./TourOverlay.vue?vue&type=style&index=0&id=10c22780&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c22780",
  null
  
)

export default component.exports